import {rootAPIUrl} from '__utils/constants'

// fetch member profile data
export const profileFetchURL =  rootAPIUrl + "/profile/";

// update member profile data
export const profileUpdateURL = rootAPIUrl + "/profile/update/";